export const KEY_CODES = {
  // Actions
  ENTER: 'Enter',
  SPACE: ' ',
  ESCAPE: 'Escape',
}
